module.exports = __webpack_public_path__ + "media/fashion-show.8db5a7eb.mp4";